<template>
  <div>
    <v-dialog
      v-model="dialog"
      width="500"
    >
      <template v-slot:activator="{ on }">
        <v-btn
          color="primary"
          :disabled='!hasKey'
          v-on="on"
          ref='algFirmaActivator'
        >
          Firmar
          <v-icon>mdi-fountain-pen-tip</v-icon>
        </v-btn>
      </template>

      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>Firmar</v-card-title>
        <v-card-text>
          <v-row>
            <v-col></v-col>
          </v-row>
          <v-row>
            <v-spacer></v-spacer>
            <v-col class="d-flex" cols="13" sm="11">
              <v-label>Algoritmos</v-label>
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn style="margin-left: 10px;" color="primary" x-small icon @click="modify = !modify" v-bind="attrs"
                    v-on="on"><v-icon>mdi-cog</v-icon></v-btn>
                </template>
                <span>Modificar Algoritmos</span>
              </v-tooltip>
            </v-col>
            <v-col class="d-flex" cols="13" sm="11">
              <v-spacer></v-spacer>
              <span style="margin-right: 20px;">Digestión: {{selectedDigest.digestMethod}}</span>
              <span>Firma: {{selectedSign.nombreAlgoritmo}}</span>
            </v-col>
            <v-spacer></v-spacer>
          </v-row>
          <v-row v-if="modify">
            <v-spacer></v-spacer>
            <v-col class="d-flex" cols="12" sm="10">
              <v-select
              v-model='selectedDigest'
              :items="gridDataDigest"
              item-text="digestMethod"
              label="Algoritmo digestión"
              return-object
              no-data-text="No hay algoritmos disponibles"
              ></v-select>
            </v-col>
            <v-spacer></v-spacer>
          </v-row>
          <v-row v-if="modify">
            <v-spacer></v-spacer>
            <v-col class="d-flex" cols="12" sm="10">
              <v-select
              v-model='selectedSign'
              :items="gridDataSign"
              item-text="nombreAlgoritmo"
              label="Algoritmo firma"
              return-object
              no-data-text="No hay algoritmos disponibles"
              ></v-select>
            </v-col>
            <v-spacer></v-spacer>
          </v-row>
          <v-row>
            <v-spacer></v-spacer>
            <v-col class="d-flex" cols="12" sm="10">
              <v-text-field label="Lugar" v-model="lugar"></v-text-field>
            </v-col>
            <v-spacer></v-spacer>
          </v-row>
          <v-row>
            <v-spacer></v-spacer>
            <v-col class="d-flex" cols="12" sm="10">
              <v-select
              v-model='selectedFirmante'
              :items="gridDataFirmante"
              item-text="selectText"
              label="Firmante"
              return-object
              no-data-text="No hay firmantes disponibles"
              :disabled="precharged"
              :outlined="precharged"
              :append-icon="precharged ? '' : 'mdi-menu-down'"
              ></v-select>
            </v-col>
            <v-spacer></v-spacer>
          </v-row>
          <v-row>
            <v-spacer></v-spacer>
            <v-col class="d-flex" cols="12" sm="10">
              <v-text-field
              v-model='password'
              label="Contraseña"
              outlined
              :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showPass ? 'text' : 'password'"
              @click:append="showPass = !showPass"
              ></v-text-field>
            </v-col>
            <v-spacer></v-spacer>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="btnFirma"
            text
            @click="firmarAlgoritmo()"
            :disabled="!readyForSignature || awaitingResponse"
          >
            Firmar
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="dialog = false"
            :disabled="awaitingResponse"
          >
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Vue from 'vue';
import { ApiInit } from '@/api';
import { mapGetters, mapActions } from 'vuex';
import * as jsrsasign from 'jsrsasign';
import { incompleteQuery } from '@/utils/checkQuery.js';
import { consoleErrorMessage, toasterErrorMessage } from '@/utils/responseCatchMessages.js';

  export default {
    props:{
      hasKey: Boolean,
      selected: Array,
      docId: String,
    },
    data () {
      return {
        modify: false,
        dialog: false,
        showPass: false,
        lugar: '',
        gridDataDigest: [],
        gridDataSign: [],
        gridDataFirmante: [],
        selectedDigest: {},
        selectedSign: {},
        selectedFirmante: {},
        precharged: false,
        datos: {
          docId: '',
          clientId: ''
        },
        resultb64: '',
        firmaId: '',
        password: '',
        awaitingResponse: false,
      }
    },
    computed: {
      readyForSignature() {
        if (Object.keys(this.selectedDigest).length > 0 && Object.keys(this.selectedSign).length > 0 && Object.keys(this.selectedFirmante).length > 0 && this.password.length > 0) return true;
        return false;
      }
    },
    mounted(){
      ApiInit().then(r => this.init() );
    },
    
    methods:{
      ...mapGetters(['getClient', 'getDocument']),
      ...mapActions(['setClient', 'setDocument']),
      async init(){
        //?c=1&d=2a0f9d80-6b09-45f5-a9a2-36730b703f76&f=5ea724c2-c49f-4665-b90b-98d7c97ae7a3
        const query = JSON.parse(JSON.stringify(this.$route.query));
        const requiredParams = ['c', 'd'];
        if (incompleteQuery(query, requiredParams)) return;
        this.precharged = true;
        this.setClient(query.c);
        this.setDocument(query.d);
        const firmante = await this.getFirmanteById(query.f);
        if (firmante === null) return;
        firmante.selectText = firmante.contacto.nombre + ', ' + firmante.razon;
        this.gridDataFirmante.push(firmante);
        this.selectedFirmante = firmante;
      },
      
      async getAlgoritmos(){
        const defaultToastMessage = 'Error al obtener la lista de algoritmos.';
        const defaultConsoleMessage = 'getAlgoritmos error';
        try {
          //this.datos.docId = this.$store.getters.getDocument;
          //this.datos.clientId = this.$store.getters.getClient;
          const clientId = this.getClient();
          //console.debug('clientId', clientId);
          const documentId = this.getDocument();
          //console.debug("Document: %o", documentId);
          const result = await this.$store.dispatch('listAlgoritmos', {clientId, documentId});
          if (result === null) {
            console.error(defaultConsoleMessage);
            this.$toast.error(defaultToastMessage);
            return;
          }
          this.gridDataSign = result;
          this.gridDataDigest = this.gridDataSign;
          this.selectedDigest = this.gridDataDigest[2];
          this.selectedSign = this.gridDataSign[2];
        }catch (e) {
          consoleErrorMessage(e, defaultConsoleMessage);
          toasterErrorMessage(this.$toast.error, e, defaultToastMessage);
        }
      },
      async getFirmanteById(firmanteId) {
        const defaultToastMessage = 'Error al obtener datos del firmante.';
        const defaultConsoleMessage = 'getFirmanteById error';
        try {
          const clienteId = this.getClient();
          const id = firmanteId;
          const response = await this.$store.dispatch('getFirmante', {id,clienteId});
          if (response === null) {
            console.error(defaultConsoleMessage);
            this.$toast.error(defaultToastMessage);
            return null;
          }
          return response;
        }catch (e) {
          consoleErrorMessage(e, defaultConsoleMessage);
          toasterErrorMessage(this.$toast.error, e, defaultToastMessage);
          return null;
        }
      },
      async getFirmantes(){
        const defaultToastMessage = 'Error al obtener la lista de firmantes.';
        const defaultConsoleMessage = 'getFirmantes error';
        try {
          const clienteId = this.getClient();
          const documentoId = this.getDocument();
          const response = await this.$store.dispatch('listFirmantesActivos', {clienteId, documentoId});
          //console.debug('firmantes', response);
          if (response === null) {
            console.error(defaultConsoleMessage);
            this.$toast.error(defaultToastMessage);
            return;
          }
          this.gridDataFirmante = response.content;
          for (const firmante of this.gridDataFirmante) firmante.selectText = firmante.contacto.nombre + ', ' + firmante.razon;
        }catch (e) {
          consoleErrorMessage(e, defaultConsoleMessage);
          toasterErrorMessage(this.$toast.error, e, defaultToastMessage);
        }
      },
      verifyKeyPassword() {
        let val = null;
        try {
          const alg = this.selectedSign.nombreAlgoritmo.slice(10);
          const key = this.selected[0].keyO;
          const pass = this.password;
          val = this.sign(alg, key, '', pass);
        } catch (e) {
          console.error('verifyKeyPassword error: %o', e);
        }
        if (typeof val !== 'string') return false;
        return true;
      },
      async firmarAlgoritmo(){
        const defaultToastMessage = 'Error al firmar el contrato.';
        const defaultConsoleMessage = 'firmarAlgoritmo error';
        try {
          this.awaitingResponse = true;
          const clienteId = this.getClient();
          const documentId = this.getDocument();
          const request = {
            certificado: this.selected[0].cert,
            digestMethod: this.selectedDigest.digestMethod,
            nombreAlgoritmo: this.selectedSign.nombreAlgoritmo,
            firmanteId: this.selectedFirmante.id,
            location: this.lugar
          };
          if (!this.verifyKeyPassword()) {
            this.$toast.error('Contraseña incorrecta.');
            this.stopWait();
            return;
          }
          const result = await this.$store.dispatch('firmarAlgoritmo', {clienteId, documentId, request});
          if (result === null) {
            console.error(defaultConsoleMessage);
            this.$toast.error(defaultToastMessage);
            this.stopWait();
            return;
          }
          //console.log("RESULT: %o", result);
          this.firmaId = result.firmaId;
          const data = result.signedInfo;
          const alg = result.algoritmo;
          const key = this.selected[0].keyO;
          const hash = result.hash;
          const HashAlg = result.hashAlgorithm;
          const pass = this.password;
          console.debug("key: %o", key);
          if(hash){
            // Opción (posiblemente) obsoleta, advertir de su uso
            console.warn('Usando signWithHash() en lugar de sign()');
            this.resultb64 = this.signWithHash(hash, key, HashAlg, pass);
          }else{
            this.resultb64 = this.sign(alg,key,data,pass);
          }
          await this.EnviarFirma();
        }catch (e) {
          consoleErrorMessage(e, defaultConsoleMessage);
          toasterErrorMessage(this.$toast.error, e, defaultToastMessage);
        }
        this.stopWait();
      },
      sign (alg, key, data, pass) {
        let sig = new jsrsasign.KJUR.crypto.Signature({alg: alg});
        let keyObj = jsrsasign.KEYUTIL.getKeyFromEncryptedPKCS8PEM(key, pass);
        sig.init(keyObj, pass);
        sig.updateHex(data);
        var sigVal = sig.sign();
        return sigVal;
        //console.debug('sigVal: %o', sigVal);
        //var b64s = jsrsasign.hextob64(sigVal);
        //console.debug('b64s: %o', b64s)
      },
      async EnviarFirma(){
        const defaultToastMessage = 'Error al firmar el contrato.';
        const defaultConsoleMessage = 'EnviarFirma error';
        try{
          this.awaitingResponse = true;
          const clienteId = this.getClient();
          const documentId = this.getDocument();
          const request = {};
          request.firmaId = this.firmaId;
          request.signatureValue = this.resultb64;
          const result = await this.$store.dispatch('SignatureValue', {clienteId, documentId, request});
          if (result === null) {
            console.error(defaultConsoleMessage);
            this.$toast.error(defaultToastMessage);
            this.stopWait();
            return;
          }
          if(result.responseStatus == 'NO_FIRMADO'){
            this.$toast.error('No se pudo firmar el contrato');
          }else{
            this.$toast.success("Contrato Firmado");
            this.$emit('signedSuccessfully');
            this.dialog = false;
          }
          //console.debug('SIGNValue: %o', result);
        }catch(e){
          consoleErrorMessage(e, defaultConsoleMessage);
          toasterErrorMessage(this.$toast.error, e, defaultToastMessage);
        }
        this.stopWait();
      },
      signWithHash(hash, key, alg, pass) {
        // utilizar este codigo si viene 'hash' en el getSignedInfo
        // RSAKey  
        alg = alg.replace("-", "");
        const hashAlg = alg.toLowerCase();
        //const md = new jsrsasign.KJUR.crypto.MessageDigest({alg: hashAlg});
        //const d = md.digestHex(hash);
        //console.debug('Message digest %s', d);
        //const sHashHex = d;
        //const keyH = new jsrsasign.RSAKey();
        //console.debug('RSAKey %o', keyH);
        let keyObj = jsrsasign.KEYUTIL.getKeyFromEncryptedPKCS8PEM(key, pass);
        //console.debug('Hash %s', hash);
        //console.debug('HashAlg %s', hashAlg);
        //console.debug('key %o', keyObj);

        Object.assign( jsrsasign.KJUR.crypto.Util.DIGESTINFOHEAD, {none:''} ); 

//console.debug ("CRYPTOJSMESSAGEDIGESTNAME %o",jsrsasign.KJUR.crypto.Util.CRYPTOJSMESSAGEDIGESTNAME);
//console.debug ("getDigestInfoHex %o",jsrsasign.KJUR.crypto.Util.getDigestInfoHex);



//        const signedValue = keyObj.signWithMessageHash(hash, hashAlg);
        const signedValue = keyObj.signWithMessageHash(hash, 'none');


//        const signedValue = this.signAPatita(hash, 'none', keyObj)

        //console.debug('%s+RSA: %o', hashAlg, signedValue);

//        const v = keyObj.verifyWithMessageHash(hash,signedValue);
//        console.debug('verify: %o', v);

        return signedValue;
      },
      stopWait() {
        var self = this;
        window.setTimeout((obj) => { obj.awaitingResponse = false; }, 500, self);
      },
    },
    watch: {
      dialog() {
        this.modify = false;
        if (this.dialog) {
          this.getAlgoritmos();
          this.getFirmantes();
        } else {
          this.selectedDigest = {};
          this.selectedSign = {};
          if (!this.precharged) this.selectedFirmante = {};
        }
      },
    }
  };
</script>
<style type="">
.container1{
  margin-left: 20px;
}
.btnFirma{
  float: left;
}
</style>